import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authToken: null,
    user: {
      name: null,
      email: null,
      trackers: []
    }
  },
  mutations: {
    setAuthToken (state, token) {
      state.authToken = token
    },
    setUser (state, user) {
      state.user = user
    }
  },
  actions: {
    async setAuthToken (context, token) {
      if (token === null) localStorage.removeItem('bart-tracker-authToken')
      else localStorage.setItem('bart-tracker-authToken', token)
      context.commit('setAuthToken', token)
    },
    async checkAuthToken (context) {
      if (context.state.authToken !== null) return true
      else if (localStorage.getItem('bart-tracker-authToken') !== null) {
        context.commit('setAuthToken', localStorage.getItem('bart-tracker-authToken'))
        return true
      } else {
        return false
      }
    },
    async setSleepTime (context, sleepObj) {
      const sleepTime = sleepObj.sleepTime
      const trackerId = sleepObj.trackerId
      try {
        const result = await fetch('/api/setTrackerSleep.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${context.state.authToken}`
          },
          body: JSON.stringify({
            sleepTime,
            trackerId
          })
        }).then(r => r.json())
        return result
      } catch (err) {
        return {
          error: true,
          message: err
        }
      }
    },
    async getSleepTime (context, trackerId) {
      try {
        const result = await fetch('/api/getTrackerSleep.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${context.state.authToken}`
          },
          body: JSON.stringify({
            trackerId
          })
        }).then(r => r.json())
        return result
      } catch (err) {
        return {
          error: true,
          message: err
        }
      }
    },
    async login (context, user) {
      try {
        const result = await fetch('/api/user/login.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json'
          },
          body: JSON.stringify({
            email: user.email,
            password: user.password
          })
        }).then(r => r.json())
        return result
      } catch (err) {
        return {
          error: true,
          message: err
        }
      }
    },
    async register (context, user) {
      try {
        const result = await fetch('/api/user/register.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json'
          },
          body: JSON.stringify({
            email: user.email,
            password: user.password,
            name: user.name
          })
        }).then(r => r.json())
        return result
      } catch (err) {
        return {
          error: true,
          message: err
        }
      }
    },
    async getUser (context) {
      if (context.state.user.name) return // User already set
      try {
        let user
        if (userFetch) user = await userFetch
        else {
          userFetch = fetch('/api/user/details.js', {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${context.state.authToken}`
            }
          }).then(r => r.json())
          user = await userFetch
        }
        if (user.error) return user
        else context.commit('setUser', user)
      } catch (err) {
        return {
          error: true,
          message: err
        }
      }
    },
    async addTracker (context, trackerId) {
      try {
        const result = await fetch('/api/user/addTracker.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${context.state.authToken}`
          },
          body: JSON.stringify({
            trackerId
          })
        }).then(r => r.json())
        if (result.trackers) {
          const newUser = Object.assign({}, context.state.user) // Clone current user object
          newUser.trackers = result.trackers
          context.commit('setUser', newUser)
        }
        return result
      } catch (err) {
        return {
          error: true,
          message: err
        }
      }
    },
    async getLatestPoints (context, { amount, trackerId }) {
      try {
        const pointsRes = await fetch('/api/getLatestPoints.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${context.state.authToken}`
          },
          body: JSON.stringify({
            amount,
            trackerId
          })
        }).then(r => r.json())
        return [null, pointsRes.points]
      } catch (err) {
        return [{
          error: true,
          message: err
        }, null]
      }
    },
    async getPoint (context, { index, trackerId }) {
      try {
        const pointCell = await fetch('/api/getPoint.js', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${context.state.authToken}`
          },
          body: JSON.stringify({
            index,
            trackerId
          })
        }).then(r => r.json())
        if (pointCell.error) {
          return [pointCell.message, null]
        } else if (pointCell && pointCell.point) {
          return [null, pointCell]
        } else {
          return [{
            error: true,
            message: 'Unkown error getting point'
          }, null]
        }
      } catch (err) {
        return [{
          error: true,
          message: err
        }, null]
      }
    }
  }
})
let userFetch // Global userfetch var, should store this somewhere else.
